<template>
	<div id="app" class="flex">
		<!-- <VuePerfectScrollbar class="scroll-area" :settings="psSettings"> -->
		<InfoBox />
		<Inbox />
		<!-- </VuePerfectScrollbar> -->
		<Notification />
	</div>
</template>

<script>
import InfoBox from "./components/InfoBox";
import Inbox from "./components/Inbox";
import Notification from "./components/Notification";
// import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
	name: "App",
	components: { InfoBox, Inbox, Notification },
	data() {
		return {
			data: {
				email: this.$bus.email,
				sessions: this.$bus.sessions,
				sessionData: this.$bus.sessionData
			}
		};
	}
};
</script>

<style lang="scss">
$primary-color: #4facfe;
$secondary-color: #00f2fe;
$font-color: #2c3e50;

/* Import Simple Line Icons Set */
// $simple-line-font-path: "~simple-line-icons/fonts/";
// @import "~simple-line-icons/scss/simple-line-icons.scss";

#app {
	font-family: "Montserrat", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: $font-color;
	margin: 80px auto;
	max-width: 1024px;
	padding: 0;
	box-shadow: 0 0 40px 30px rgba(0, 0, 0, 0.1);
	background: #fff;
	align-items: stretch;
	min-height: 500px;
}
.flex {
	display: flex;
	align-items: center;
	justify-content: flex-start;

	&-space-between {
		justify-content: space-between;
	}

	&-sm {
		@media screen and (max-width: 767px) {
			display: block;
		}
	}
}
.btn {
	background: transparent;
	border: 1px solid $primary-color;
	outline: none;
	border-radius: 3px;
	line-height: 1;
	padding: 10px;
	display: inline-flex;
	align-items: center;
	justify-content: space-evenly;
	font-size: 0.85rem;
	text-transform: uppercase;
	font-weight: 500;
	color: $font-color;
	cursor: pointer;

	&.primary {
		background: $primary-color;
		color: #fff;
		&:hover {
			background: darken($primary-color, 5);
			box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
		}
	}

	&.plain {
		border: none;
		padding: 0;
	}

	span {
		margin: 0 0 0 6px;
	}
}
.masthead {
	background: #5fb6ad;
	padding: 0 20px;
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	color: #fff;

	.logo {
			opacity: 0.7;
		svg {
			width: 20px;
			stroke: #fff;
			margin-right: 10px;
		}
		span {
			font-size: 18px;
		}
	}
}

@media screen and (max-width: 767px) {
	#app {
		text-align: center;
	}
}
</style>
